<nav class="navbar navbar-expand-lg navbar-dark fixed-top shadow-sm ">
  <div class="container-fluid justify-content-center" *ngIf="!UserLoggedIn">
    <a class="navbar-brand m-3" >
      <img 
        src="assets/Images/Beon-DLP-Logo-White-web.png" 
        alt="Beon DLP Logo" 
        width="250"
        class="d-inline-block align-center"
        />
    </a>
  </div>
  <div class="container-fluid" *ngIf="UserLoggedIn">
    <a
      class="navbar-brand ps-5"
      routerLink=""
      [ngClass]="{ noclick: UserLoggedIn }">
      <img src="assets/Images/Batch-Rater-white.png" alt="Batch Rater" />
    </a>
    <button
      class="navbar-toggler"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent"
      aria-expanded="false"
      aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav me-auto mb-2 mb-lg-0 ps-5">
        <div *ngFor="let i of Menus; let idx = index">
          <div *ngIf="i.subMenu == null">
            <li
              class="nav-item cursorPointer pe-4"
              routerLinkActive="underline">
              <a
                class="nav-link"
                [class.active]="selectedIndex == idx"
                [class.underline]="selectedIndex == idx"
                (click)="OnPageLode(i.path, idx)"
                aria-current="page"
                routerLinkActive="active"
                >{{ i.menuName }}</a
              >
            </li>
          </div>

          <div *ngIf="i.subMenu != null">
            <li
              class="nav-item cursorPointer dropdown"
              routerLinkActive="underline underline2">
              <a
                class="nav-link dropdown-toggle"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false">
                {{ i.menuName }}
              </a>
              <ul class="dropdown-menu">
                <li *ngFor="let subMenu of i.subMenu">
                  <a
                    class="dropdown-item"
                    routerLink="{{ subMenu.path }}"
                    routerLinkActive="active"
                    >{{ subMenu.menuName }}</a
                  >
                </li>
                <!-- <li>
                                    <hr class="dropdown-divider">
                                </li> -->
                <!-- <li><a class="dropdown-item" href="#">Something else here</a></li> -->
              </ul>
            </li>
          </div>
        </div>
      </ul>
      <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
        <div>
          <li class="nav-item dropdown">
            <a
              class="nav-link dropdown-toggle active"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false">
              {{ UserFullName }}
            </a>
            <ul class="dropdown-menu">
              <li>
                <a
                  class="dropdown-item"
                  aria-current="page"
                  href="#"
                  *ngIf="(authStateService.authState$ | async)?.isAuthenticated"
                  (click)="logout($event)"
                  >Sign Out</a
                >
              </li>
            </ul>
          </li>
        </div>
      </ul>
    </div>
  </div>
</nav>

<!-----------------------------Confirmation------------------------->
<div class="ConfirmationPopUp">
  <p-dialog
    [resizable]="true"
    header="Confirmation"
    id="IsConfirmation"
    [(visible)]="IsConfirmation"
    [modal]="true">
    <div>
      <label>{{ FileInProgressMessage }}</label>
    </div>
    <ng-template pTemplate="footer">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-6">
            <span></span>
          </div>
          <div class="col-md-3 batchrater-cancel-button">
            <button
              pButton
              pRipple
              type="button"
              (click)="cancelProcess()"
              label="Cancel"
              class="p-button-info p-button-text"></button>
          </div>
          <div class="col-md-3 batchrater-delete-user-button">
            <button
              pButton
              pRipple
              type="button"
              (click)="continueRedirect()"
              label="Ok"
              class="UserButton"
              displayBasic="false"></button>
          </div>
        </div>
      </div>
    </ng-template>
  </p-dialog>
</div>
